document.addEventListener("DOMContentLoaded", () => {
  const siteMain = document.querySelector('.site-main');
  if(siteMain){
    setMainPaddingBottom();
    window.addEventListener("resize", setMainPaddingBottom);
    window.addEventListener("orientationchange", setMainPaddingBottom);
  }

  const widgetTitles = document.querySelectorAll(".footer-widget .widget-title");
  const menus = document.querySelectorAll(".footer-widget .menu");

  widgetTitles.forEach((title, index) => {
    title.addEventListener("click", function (event) {
      const titleRect = title.getBoundingClientRect(); // Get the position of the title
      const afterWidth = 20; // Width of the `::after` pseudo-element (adjust based on your CSS)
      const afterHeight = 20; // Height of the `::after` pseudo-element (adjust based on your CSS)
      
      // Check if the click happened inside the area where the ::after is located
      const isClickOnAfter = event.clientX >= titleRect.right - afterWidth && event.clientY >= titleRect.top && event.clientY <= titleRect.bottom;
      
      // if (isClickOnAfter && menus[index]) {
      //   title.classList.toggle("active");
      //   const footerMenuHeight = title.nextElementSibling.scrollHeight + "px"; // Get the height of the menu
      //   menus[index].classList.toggle("active");
      //   setTimeout(() => {
      //   }, 200);
      // }
      if (isClickOnAfter && menus[index]) {
      title.classList.toggle("active");
      menus[index].classList.toggle("active");

      const menu = menus[index];

      if (menu.style.maxHeight) {
        // Collapse
        menu.style.maxHeight = null;
      } else {
        // Expand using scrollHeight
        menu.style.maxHeight = menu.scrollHeight + "px";
      }
    }
    });
  });
});
function setMainPaddingBottom() {
  let footer = document.querySelector(".site-footer");
  let main = document.querySelector(".site-main");
  footerHeight = footer.offsetHeight;

  main.style.paddingBottom = footerHeight + "px";
  main.style.marginBottom = "-" + footerHeight + "px";
}
